module.exports = __webpack_public_path__ + "img/espresso.c24f9ee5.png";